import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "src/store/features/auth/axiosCSRF";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";


interface iUserActivityState {
  user_id: string;
  has_logged_in: boolean;
  last_login_at: string;
  last_login_at_kst: string;
  workflows: {
    drug_response:{
        has_run: boolean;
        run_count: number;
        guide_modal_show: boolean;
    },
    ppi_inhibitor:{
        has_run: boolean;
        run_count: number;
        guide_modal_show: boolean;
    },
    kinase_inhibitor:{
        has_run: boolean;
        run_count: number;
        guide_modal_show: boolean;
    }
  }
}

export interface iUserMyActivityState {
    response : iUserActivityState | null;
    isLoading : boolean;
    message : string | null;
}

const initialState : iUserMyActivityState = {
    response : null,
    isLoading : false,
    message : null,
}

export const getUserMyActivityHistoryAPI = createAsyncThunk(
    "GET_USER_MY_ACTIVITY_HISTORY",
    async (_, { rejectWithValue }) => {
        try {
            const djangoEndpoint = getDjangoEndpoint();
            const pathParam = `/auth/user-activity/`;
            const response = await axiosInstance.get(`${djangoEndpoint}${pathParam}`);
            return response.data;
        } catch (e) {
            console.error('User My Activity API 에러:', e);
            return rejectWithValue(e.response ? e.response.data : e.message);
        }
    }
)

export const userMyCreditBalanceHistorySlice = createSlice({
    name : "userMyActivityHistory",
    initialState,
    reducers : {},
    extraReducers : (builder) => {
        builder
        .addCase(getUserMyActivityHistoryAPI.pending, (state) => {
            state.isLoading = true;
            state.message = null;
        })
        .addCase(getUserMyActivityHistoryAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.response = action.payload;
        })
        .addCase(getUserMyActivityHistoryAPI.rejected, (state, action) => {
            state.isLoading = false;
            state.message = action.payload as string;
        })
    }
})

export default userMyCreditBalanceHistorySlice.reducer;

